var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.opened
        ? _c("div", { staticClass: "modal-mask" }, [
            _c("div", { staticClass: "modal-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Sensitivity analysis"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", [
                        _c("p", [
                          _vm._v("Criterion: "),
                          _c(
                            "a",
                            {
                              staticClass: "text-primary",
                              on: { click: _vm.showCriterionSelector },
                            },
                            [_vm._v(_vm._s(_vm.selectedCriterionName))]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.goalSelected
                          ? _c(
                              "div",
                              {
                                staticClass: "alert alert-warning",
                                attrs: { role: "alert" },
                              },
                              [
                                _vm._v(
                                  "\n                                Please select a criterion. Sensitivity analysis in the context of root is not available.\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm._m(0),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Close")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("CriterionSelectorDialog", {
        attrs: { viewModel: _vm.criterionSelectorDialog },
        on: { "confirm-selection": _vm.handleChangeCriterion },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticStyle: { "max-height": "calc(100vh-200px)", overflow: "auto" } },
      [_c("div", { attrs: { id: "Chart-SensitivityAnalysisChart" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }